import { ROLES_KEYS, SupportingCompanyAccessLevel, UserProcessStatus } from '@interfaces';
import { Pagination } from './http';
import { USER_TAGS } from './user-tags';

export interface SearchForeignersPayload extends Pagination {
  query?: string;
  companyId?: string;
  showDeleted?: boolean;
  showInactive?: boolean;
  creatorId?: string;
  userOrigin?: USER_ORIGIN;
  tags?: USER_TAGS[];
}

export interface GetEmployeesPayload extends Pagination {
  query?: string;
  roles?: string[];
  rolesKeys?: ROLES_KEYS[];
  showDeleted?: boolean;
  showOnlyActive?: boolean;
  officeId?: string;
  supportedUserOrigins?: USER_ORIGIN[];

  // If you provide 'supportingCompanyId' you must also provide 'supportingCompanyAccessLevel'
  supportingCompanyId?: string;
  // If you provide 'supportingCompanyAccessLevel' you must also provide 'supportingCompanyId'
  supportingCompanyAccessLevel?: SupportingCompanyAccessLevel;
}

export interface GetAdminsPayload extends Pagination {
  query?: string;
}
export interface GetOnlineUsersPayload extends Pagination {
  query?: string;
  roles?: string[];
}

export interface GetUsersPayload extends Pagination {
  // array of uuids
  roles?: string[];
  companyId?: string;
  query?: string;
  showDeleted?: boolean;
  showInactive?: boolean;
}

export interface SearchUsersProcessesPayload extends Pagination {
  status?: UserProcessStatus;
  creatorId?: string;
  officeVisitDate?: string; // DD.MM.YYYY | DD.MM.YYYY HH:mm -> used: " userProcess.officeVisitDate ILIKE '[date]%'; ",
  query?: string;
  companyId?: string;
  missingAssistant?: boolean;
}

export enum USER_ORIGIN {
  // FOreigner registered with self-registration form
  SELF_REGISTERED = 'SELF_REGISTERED',

  // Employee created account for foreigner and sent activation-link to provided email address
  INVITED = 'INVITED',
}

export interface SelfRegisterOpts {
  email: string;
  name: string;
  telephoneNumber: string;
  langKey: string;
  hasAcceptedGDPR: boolean;
  hasAcceptedDataProcessing: boolean;
  referalCode?: string;
}

export interface ReassignForeignersOpts {
  currentEmployeeId: string;
  foreignersIds: string[];
  newEmployeeId: string;
}

export interface SearchUserActivityOpts extends Pagination {
  userId: string;
  query?: string;
  companyId?: string;
  userOrigin?: USER_ORIGIN;
}
